import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery, useQueryClient } from '@tanstack/react-query'

import type { getControllerConfigLatestVersionParams } from '@/features/controller/configuration/endpoints/controllerConfiguration'
import {
  GET_LATEST_CONFIG_VERSION_API,
  getControllerConfigLatestVersion,
} from '@/features/controller/configuration/endpoints/controllerConfiguration'
import type { ControllerConfigVersion } from '@/features/controller/configuration/types'
import type { UseQueryOptions } from '@/types/queries'

export type UseControllerConfigLatestVersionQueryResult = Omit<UseQueryResult, 'data'> & {
  latestConfigVersion: ControllerConfigVersion | null
}

export function useLatestControllerConfiguration(
  params: getControllerConfigLatestVersionParams,
  options?: UseQueryOptions<ControllerConfigVersion | null>,
): UseControllerConfigLatestVersionQueryResult {
  const { data, ...queryResult } = useQuery<ControllerConfigVersion | null>({
    ...options,
    queryFn: () => getControllerConfigLatestVersion(params),
    queryKey: [GET_LATEST_CONFIG_VERSION_API, params],
  })

  return {
    ...queryResult,
    latestConfigVersion: data || null,
  }
}

export function useInvalidateLatestControllerConfiguration() {
  const queryClient = useQueryClient()

  return (params: getControllerConfigLatestVersionParams) =>
    queryClient.invalidateQueries({
      queryKey: [GET_LATEST_CONFIG_VERSION_API, params],
    })
}
